export default __webpack_public_path__ + "static/media/bottom_review_contents.d1392afb.png";